export const NOTARY_SETUP_ALERT_KEY = 'notary-setup-alert-dismissed';

export const RECOVERY_EMAIL_RECOMMENDED = 'recovery-email-recommended';
export const RECOVERY_EMAIL_UNVERIFIED = 'recovery-email-unverified';
